import { Box } from "@mui/material";
import * as React from "react";
import TabComponent from "components-base/Tab/Tab";
import EntradaMaquila from "components-base/entradaMaquila";

const _EntradasMaquila = () => {
  const tabsElements = [
    {
      label: "Entrada de Maquila",
      component: <EntradaMaquila />,
    },
  ];

  return (
    <Box>
      <TabComponent tabsElement={tabsElements} />
    </Box>
  );
};
export default _EntradasMaquila;
